import { useEffect, useState } from 'react';

export const useExternalScript = (
  url,
  isScriptAvailable,
  options = { appendHead: true, scriptAttributes: {}, ignore: false },
) => {
  let [state, setState] = useState(url ? 'loading' : 'idle');

  useEffect(() => {
    if (options.ignore) {
      return;
    }
    if (state === 'ready') {
      return;
    }
    if (!url) {
      setState('idle');
      return;
    }

    let script = document.querySelector(`script[src="${url}"]`);
    const handleScript = (e) => {
      setState(e.type === 'load' ? 'ready' : 'error');
    };

    if (!script) {
      script = document.createElement('script');
      script.type = 'application/javascript';
      script.src = url;
      script.async = true;
      for (const [key, value] of Object.entries(options.scriptAttributes)) {
        script.setAttribute(key, value);
      }
      if (options.appendHead) {
        document.head.appendChild(script);
      } else {
        document.body.appendChild(script);
      }
      script.addEventListener('load', handleScript);
      script.addEventListener('error', handleScript);
    } else if (isScriptAvailable && isScriptAvailable()) {
      console.log('Learnosity script is available, mark state as ready...');
      handleScript({ type: 'load' });
    }

    script.addEventListener('load', handleScript);
    script.addEventListener('error', handleScript);

    return () => {
      script.removeEventListener('load', handleScript);
      script.removeEventListener('error', handleScript);
    };
  }, [state, url, isScriptAvailable, options]);

  return state;
};
